// PageDescription: 비대면진료 증상과목 카테고리 페이지
import TelemedicineCategoriesTemplate from '@/components/templates/telemedicine/category/TelemedicineCategoriesTemplate';
import useGetDiagnosisCategories from '@/hooks/telemedicine/useGetDiagnosisCategories';
import useTelemedicineCategoriesViewModel from '@/hooks/telemedicine/useTelemedicineCategoriesViewModel';
import { CustomPageProps } from '@/types/app';
import { ROUTES } from '@/types/common';
import { addQueryString } from '@/utils/url';
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';

const TelemedicineCategoriesPage = ({ client }: CustomPageProps) => {
  const viewModel = useTelemedicineCategoriesViewModel();
  return (
    <>
      <NextSeo
        title='비대면 진료 가능한 의사 전체 보기 | 진료과·질환별 원격진료 - 닥터나우'
        description='내 증상에 맞는 의사를 빠르게 찾고, 병원 방문 없이 비대면 진료로 약 처방까지 받아보세요. 감기, 여드름, 탈모, 다이어트, 소아과, 인공눈물 등 다양한 진료과별 전문의가 실시간 대기 중입니다.'
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_DOMAIN}${ROUTES.TELEMEDICINE.CATEGORIES.path}${addQueryString({
            type: viewModel.selectedCategoryType,
          })}`,
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: '비대면 진료, 원격진료, 진료과 전체 보기, 온라인 진료, 감기, 탈모, 여드름, 소아과, 인공눈물',
          },
        ]}
        canonical={`${process.env.NEXT_PUBLIC_DOMAIN}${ROUTES.TELEMEDICINE.CATEGORIES.path}${addQueryString({
          type: viewModel.selectedCategoryType,
        })}`}
      />
      <TelemedicineCategoriesTemplate client={client} viewModel={viewModel} />
    </>
  );
};
export default TelemedicineCategoriesPage;

export const getServerSideProps: GetServerSideProps = async () => {
  const queryClient = new QueryClient();

  await useGetDiagnosisCategories.prefetchQuery(queryClient);

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
  };
};
